module.exports = __webpack_public_path__ + "img/bespoke70_25.161a968f.jpg";